import React from 'react'
import FirebaseContext from "../../firebase/context";
import CompTemaListEdit from './CompTemaListEdit';

import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Button } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';


const useStyles = makeStyles({
    table: {
        minWidth: 700,
    },
});

const CompTemaList = ({ tema, index, setTemaSelect, setUpdateTemaList, setDidableTemaBtnAdd, setPracticaURL, practicaURL }) => {

    const classes = useStyles();

    const { firebase } = React.useContext(FirebaseContext);
    const [showTemaFormEdit, setShowTemaFormEdit] = React.useState(false);
    let idTema = tema.id;
    let tituloTema = tema.tituloTema;

    const eliminarTema = id => {
        firebase.db
            .collection("colTemas")
            .doc(id)
            .delete()
            .then(success => {
                setTemaSelect(idTema);
            });
    };

  

    return (
        <React.Fragment key={index}>
            <TableRow
                hover
                // aria-checked={selected}
                // selected={selected}
                role="checkbox"
                onClick={() => {
                    setTemaSelect(idTema);
                    setDidableTemaBtnAdd(false)
                }}>
                <TableCell component="th" scope="row">{tituloTema}</TableCell>
                <TableCell align="right">
                    <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        className={classes.button}
                        startIcon={<EditIcon />}
                        onClick={() => setShowTemaFormEdit(true)}
                    >
                        EDITAR
                               </Button>
                    <Button
                        variant="contained"
                        color="error"
                        size="small"
                        className={classes.button}
                        startIcon={<DeleteIcon />}
                        onClick={() => eliminarTema(idTema)}
                    >
                        ELIMINAR
                               </Button>
                </TableCell>
            </TableRow>
            {showTemaFormEdit
                ? <CompTemaListEdit
                    tema={tema}
                    setShowTemaFormEdit={setShowTemaFormEdit}
                    setUpdateTemaList={setUpdateTemaList}
                    index={index}
                    setPracticaURL={setPracticaURL}
                    practicaURL={practicaURL}
                />
                : null
            }

        </React.Fragment>
    )
}

export default CompTemaList
